import React, { PureComponent } from 'react';
import { Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import utils from '@utils';
import './EstimateSummary.scss';

class EstimateSummary extends PureComponent {
	renderRow = (label, value) => (
		<div
			key={`estimate_row_${label}_${value}`}
			className="margin-bottom-15 flex flex-align-items-center flex-justify-content-space-between"
		>
			<span className="font-bold margin-right-15">{ label }</span>
			<span>{ value }</span>
		</div>
	)

	handleAccept = () => {
		const { approveEstimate } = this.props;
		approveEstimate(true);
	}

	handleCancel = () => {
		const { step, changeStep, clearNote } = this.props;

		if (step === 'info') changeStep('decline');
		else {
			changeStep('info');
			clearNote();
		}
	}

	render() {
		const {
			invoiceEstimate,
			isRecurring,
			loading,
			step,
			isPrepay,
			isPaid,
		} = this.props;
		const {
			AvgRate = 0,
			TotalOfficers = 0,
			TotalOfficerPay = 0,
			TotalOrganizationFee = 0,
			TotalJurisdictionFee = 0,
			RKPayFee = 0,
			Tax = 0,
			Total = 0,
			WeeklyTotal = 0,
			RecurrenceTotal,
		} = invoiceEstimate;

		return (
			<div className="estimate-summary padding-40 padding-left-xs-20 padding-right-xs-20 bg-gray-whisper">
				<div className="font-size-16 font-semi-bold">Estimate</div>
				<hr />
				{ this.renderRow('Avg. Officer Rate', `${utils.currencyFormatter(AvgRate)}/hour`) }
				{ this.renderRow('Total Officers', TotalOfficers) }
				<hr />
				{ this.renderRow('Subtotal', utils.currencyFormatter(TotalOfficerPay)) }
				{ this.renderRow('Coordinator Fees', utils.currencyFormatter(TotalOrganizationFee)) }
				{ this.renderRow('Jurisdiction Fees', utils.currencyFormatter(TotalJurisdictionFee)) }
				{ this.renderRow('RollKall Fees', utils.currencyFormatter(RKPayFee)) }
				{ this.renderRow('Taxes', utils.currencyFormatter(Tax)) }
				<hr />
				{ this.renderRow('Total', utils.currencyFormatter(Total)) }
				{ isRecurring && this.renderRow('Weekly Total', utils.currencyFormatter(RecurrenceTotal === null ? WeeklyTotal : RecurrenceTotal)) }
				<If condition={!isPaid && step !== 'final' && step !== 'expired'}>
					<hr />
					<Row>
						<Button
							type="button"
							id="accept-button"
							onClick={this.handleAccept}
							bsStyle="primary"
							disabled={loading || step !== 'info'}
						>
							{ isPrepay ? 'Pay for Job' : 'Approve' }
						</Button>
					</Row>
					<Row>
						<Button
							type="button"
							id="decline-toggle-button"
							onClick={this.handleCancel}
							bsStyle="link"
							disabled={loading}
						>
							{ step === 'info' ? 'Decline' : 'Cancel' }
						</Button>
					</Row>
				</If>
			</div>
		);
	}
}

EstimateSummary.propTypes = {
	invoiceEstimate : PropTypes.object,
	step            : PropTypes.string.isRequired,
	loading         : PropTypes.bool.isRequired,
	changeStep      : PropTypes.func.isRequired,
	approveEstimate : PropTypes.func.isRequired,
	clearNote       : PropTypes.func.isRequired,
	isPrepay        : PropTypes.bool,
	isRecurring     : PropTypes.bool,
	isPaid          : PropTypes.bool,
};

EstimateSummary.defaultProps = {
	invoiceEstimate : {},
	isPrepay        : false,
	isRecurring     : false,
	isPaid          : false,
};

export default EstimateSummary;
